<template>
  <div @click="$router.push('/')" class="flex flex-col justify-center">
    <img src="../assets/logo.svg" alt="Cibus">
    <p class="text-4xl text-gray-100">{{ title }}</p>
  </div>
</template>

<script>
export default {
    props: {
        title: String
    }
}
</script>

<style>

</style>